"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Transition = _interopRequireDefault(require("react-transition-group/Transition"));

require("../../css/shared/animated_height.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AnimatedHeight =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AnimatedHeight, _React$Component);

  function AnimatedHeight() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AnimatedHeight);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnimatedHeight)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setHeight", function (node, height) {
      // eslint-disable-next-line no-param-reassign
      node.style.height = height; // eslint-disable-next-line no-unused-expressions

      window.getComputedStyle(node).height;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onExitOrEnter", function (node) {
      return _this.setHeight(node, "".concat(_this.wrapperRef.getBoundingClientRect().height, "px"));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onEntered", function (node) {
      return _this.setHeight(node, 'auto');
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onExiting", function (node) {
      return _this.setHeight(node, null);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "endListener", function (node, done) {
      node.addEventListener('transitionend', done, false);
    });

    return _this;
  }

  _createClass(AnimatedHeight, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          other = _objectWithoutProperties(_this$props, ["children", "className"]);

      return _react.default.createElement(_Transition.default, _extends({}, other, {
        addEndListener: this.endListener,
        onEnter: this.onExitOrEnter,
        onEntered: this.onEntered,
        onExit: this.onExitOrEnter,
        onExiting: this.onExiting
      }), function (state) {
        var _classNames;

        var containerClassName = (0, _classnames.default)((_classNames = {
          'vn-animated-height__container': true
        }, _defineProperty(_classNames, "vn-animated-height__container--".concat(state), ['entering', 'entered', 'exiting'].indexOf(state) !== -1), _defineProperty(_classNames, className, className !== undefined), _classNames));
        return _react.default.createElement("div", {
          className: containerClassName
        }, _react.default.createElement("div", {
          className: "vn-animated-height__wrapper",
          ref: function ref(_ref) {
            _this2.wrapperRef = _ref;
          }
        }, _react.default.createElement("div", {
          className: "vn-animated-height__wrapper-inner"
        }, children)));
      });
    }
  }]);

  return AnimatedHeight;
}(_react.default.Component);

AnimatedHeight.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  in: _propTypes.default.bool
};
AnimatedHeight.defaultProps = {
  className: undefined,
  in: false
};
var _default = AnimatedHeight;
exports.default = _default;